import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { getCollectList } from "../../crud/auth.crud"
import { getTopData } from "../../crud/dashboard.crud"
import { getCollectZoneList, getCarList, getDriverList } from "../../crud/search.crud"
import { getCompanyList, getTreatmentCompanyList } from "../../crud/contract.crud"
import { saveWasteCollect, updateWasteCollectReport, getWasteBinList } from "../../crud/collect.crud"
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import SelectBox from "components/RopikCustom/SelectBox.js";
import Modal from "components/RopikCustom/Modal_v2";
import * as XLSX from 'xlsx';

const initSearchCondition = {
  companyName: '',
  collectZone: '',    
  car: '',  
  collectDate: '',  
  startDate: '',
  endDate: '',
  month: '',
  driver: '',
}


const initInputCondition = {
  id: '',
  companyName: '',
  treatmentCompanyName : '',
  collectZone: '',    
  car: '',  
  collectDate: moment().hour() < 14 ? moment().clone().subtract(1, 'day').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
  driver: '',
  report: 'N',
  qty: 0,
  price: 0,
  min_price: 0,
  min_l : 0,
  is_vat: 'Y',
  billing_type: '종량제',
  rf_id : '',
  qty_type : 'l',
  state: 'I'
}

const initDashboardItem = [
  {text: '금일 총 수거량', unit: 'ℓ', value: 0},
  {text: '금일 총 인계량', unit: 'ton', value: 0},
  {text: '전일 총 수거량', unit: 'ℓ', value: 0},
  {text: '전일 총 인계량', unit: 'ton', value: 0},
]

const monthData = [
  {id : '01', name : '1월'},
  {id : '02', name : '2월'},
  {id : '03', name : '3월'},
  {id : '04', name : '4월'},
  {id : '05', name : '5월'},
  {id : '06', name : '6월'},
  {id : '07', name : '7월'},
  {id : '08', name : '8월'},
  {id : '09', name : '9월'},
  {id : '10', name : '10월'},
  {id : '11', name : '11월'},
  {id : '12', name : '12월'}
]

const stateData = [
  {id : 'I', name : '미완료'},
  {id : 'Y', name : '완료'},
  {id : 'N', name : '미수거'},  
]

const CollectHistory = () => {

  const selector = useSelector(state => state)
  const newDate = new Date()      
  const history = useHistory()

  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [modalShow, setModalShow] = useState({
    edit: false,
    deactivate: false
  })
  const [selectedCompany, setSelectedCompany] = useState('')
  const [dashboardItem, setDashboardItem] = useState(initDashboardItem)
  const [user, setUser] = useState(selector.auth?.user);
  const [dataList, setDataList] = useState([]);
  const [collectZoneData, setCollectZoneData] = useState([]);
  const [carData, setCarData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [treatmentCompanyData, setTreatmentCompanyData] = useState([]);
  const [driverData, setDriverData] = useState([]);  
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);    
  const [date, setDate] = useState(moment(newDate).format('YYYY.MM.DD'));    
  const [month, setMonth] = useState();        
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM-DD') + ' 00:00:00');
  const [endDate, setEndDate] = useState(moment(new Date(newDate.setDate(newDate.getDate() + 1))).format('YYYY-MM-DD') + ' 00:00:00');    
  const [isLoading, setIsLoading] = useState(false);    
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()    
  const [selectedItem, setSelectedItem] = useState(initInputCondition)
  const [wasteBinData, setWasteBinData] = useState()    

  const getCompanyData = async () => {
    try {
      const response = await getCompanyList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          let items = []
          for(let i=0; i< content.length; i++){            
            const rs = content[i]
            const item = {
              id : rs.company || '',
              name : rs.company_name || '',
              contract : rs.contract || '',
              billing_type : rs.billing_type == 'P' ? '종량제' : '정액제',              
              price: rs.price,
              min_price : rs.min_price,
              min_l : rs.min_l,
              collect_type: rs.collect_type || 'l'
            }
            items.push(item)
          }
          console.log(items)
          setCompanyData(items)
        } else {
          setCompanyData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getSummaryData = async () => {
    try {
      const response = await getTopData();
      if (response.status === 200) {
        const content = response.data?.data || [];
        console.log(content)
        const item = [
          {text: '금일 총 수거량', unit: 'ℓ', value: Util.setCommaPrice(content?.todate_collect_qty_sum)},
          {text: '금일 총 인계량', unit: 'ton', value: Util.setCommaPrice(content?.todate_wearing_qty_sum)},
          {text: '전일 총 수거량', unit: 'ℓ', value: Util.setCommaPrice(content?.yesterday_collect_qty_sum)},
          {text: '전일 총 인계량', unit: 'ton', value: Util.setCommaPrice(content?.yesterday_wearing_qty_sum)},
        ]
        setDashboardItem(item)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCollectZoneDataList = async () => {
    try {
      const response = await getCollectZoneList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCollectZoneData([...content])
        } else {
          setCollectZoneData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDriverDataList = async () => {
    try {
      const response = await getDriverList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDriverData([...content])
        } else {
          setDriverData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])      
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDataList = async (item) => {
    if (isFetching || isListEnd) {            
        return;
    }
    setIsLoading(true)
    setIsFetching(true)
    try {
    
      let newDate = moment(new Date()).format('YYYY-MM-DD')            
      let tomorrow = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');

      const params = {
        driver_company: user.member_group?.[0]?.company_group?.id,
        company_name : item?.companyName || '',
        collect_zone : item?.collectZone || '',
        car : item?.car || '',
        driver : item?.driver || '',
        start_date: item?.startDate || newDate,
        end_date: item?.endDate || tomorrow,
        page: page,
      }

      const response = await getCollectList(params);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDataList([...content])
          setIsFetching(false)
        } else {  
          setDataList([])                  
          setIsFetching(false)          
        }
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  };

  useEffect(()=>{    
    getSummaryData()
    getCollectZoneDataList()
    getCarDataList()
    getCompanyData()
    getDriverDataList()
  },[])

  useEffect(() => {
    getDataList();
  }, [page])

  const changeSearchCondition = (key, value) => {
    if(key == 'month' && value){      
      let now = moment();
      let currentMonth = now.month() + 2; // moment는 0~11 이라 +1
      
      let selectedMonth = parseInt(value, 10);
      let year;
      if (selectedMonth >= currentMonth) {
        year = now.year() - 1; // 이번 달부터는 작년
      } else {
        year = now.year();     // 그전까지는 올해
      }
      let startDate = `${year}-${value}-01`;
      let endDate = moment(startDate).add(1, 'month').format('YYYY-MM-DD');
      setSearchCondition(prev => ({...prev, [key]: value, startDate, endDate}))
    }else{
      setSearchCondition(prev => ({...prev, [key]: value}))
    }
  }

  const validation = () => {

  }

  const saveCollectItem = async () => {    
    try {
      setIsLoading(true)
      const params = {
          id : selectedItem?.id || '',
          company_id: selectedItem?.companyName,
          treatment_company_id : selectedItem?.treatmentCompanyName,
          contract : selectedItem?.contract_id,
          collect_zone: selectedItem?.collectZone,
          car_id: selectedItem?.car,
          collect_date: selectedItem?.collectDate,          
          qty: selectedItem?.qty,         
          qty_type: selectedItem?.qty_type,         
          is_vat: selectedItem?.is_vat, 
          driver_id: selectedItem?.driver,
          price: selectedItem?.price,
          report: selectedItem?.report,
          memo: selectedItem?.memo,
          rf_id : selectedItem?.rf_id,
          state : selectedItem?.state,
      }
      const response = await saveWasteCollect(params);            
      modalClose('write')      
      onSearch()
      setIsLoading(false)
      if (response.status == 200){
        alert('정상적으로 처리되었습니다.')
      }      
    } catch (error) {
      alert(error.response.data?.msg)        
      setIsLoading(false)      
    }
  }

  useEffect(()=>{
    console.log('searchCondition changed:', searchCondition);
  },[searchCondition])

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key] : true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
    setSelectedItem(initInputCondition)
  }

  const modalDeactivateClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
  }
  

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'수거내역 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const onSearch = async() => {
    const params = {...searchCondition}
    getDataList(params)    
    getSummaryData()
  }

  const changeInputCondition = (key, value) => {
    setSelectedItem(prev => ({...prev, [key]: value}))
  }

  const getWasteBinData = async (company_id) => {
    try {      
      const response = await getWasteBinList(company_id);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {          
          setWasteBinData([...content])
        } else {
          setWasteBinData([])
        }
      }      
    } catch (error) {
      console.error(error);     
    }
  }

  const getTreatmentCompanyData = async (contract_id) =>{
    try {
      setIsLoading(true)
      const response = await getTreatmentCompanyList(contract_id);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setTreatmentCompanyData([...content])
        } else {
          setTreatmentCompanyData([])
        }
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }

  const changeWasteBinInputCondition = (key, value) => {     
    const val = selectedItem?.waste_bin_collect_data?.filter(itm => itm.rf_id == value)        
    setSelectedItem(prev => ({...prev, [key]: value, qty: val?.[0]?.qty || 0}))    
  }

  const changeCompanyInputCondition = (key, value) => {      
    const val = companyData.filter(itm => itm.id == value)         
    getTreatmentCompanyData(val?.[0]?.contract || '')  
    getWasteBinData(val?.[0]?.id)
    setSelectedItem(prev => ({...prev, [key]: value, collectZone: val?.[0]?.collect_zone,  qty_type: val?.[0]?.collect_type || 'l',  billing_type: val?.[0]?.billing_type ? val?.[0]?.billing_type == 'P' ? '종량제' : '정액제' : '' , price: val?.[0]?.price, min_price: val?.[0]?.min_price || '', min_l: val?.[0]?.min_l || '' }))    
  }

  useEffect(() => {
    getDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>수거내역 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="수거 관리" breadcrumbItem="수거내역 관리" />

          <Row>
            <Col xs='12'>
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호명</td>
                          <td className="col-20">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                              changeSearchCondition('companyName', e.target.value)
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">수거구역 선택</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.collectZone}
                              onChange={changeSearchCondition}
                              options={collectZoneData}
                              keyValue={'collectZone'}
                            />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.car}
                              onChange={changeSearchCondition}
                              options={carData}
                              keyValue={'car'}
                            />
                          </td>
                          <td className="col-10 padding-left-8 no-border" rowSpan={3}>
                            <div className="d-flex flex-direction-column align-items-end">
                              <button type="button" className="custom-btn btn-dark-gradient w-80 margin-bottom-8 border-radius-0 white-text border-none margin-right-0" onClick={() => {
                                onSearch()
                              }}>
                                검색
                              </button>
                              <button type="button" className="custom-btn w-80 border-radius-0 primary-bg white-text button-border margin-right-0" onClick={() => {
                                modalOpen('write')
                              }}>
                                수거량 수동 등록
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">검색기간</td>
                          <td className="col-20">
                            <input style={{width: 'calc((100% - 4px) / 2)'}} className="waver-input-box border-radius-0 margin-right-4" type="date" value={searchCondition.startDate} onChange={(e) => {
                              changeSearchCondition('startDate', e.target.value);
                            }} />
                            <input style={{width: 'calc((100% - 4px) / 2)'}} className="waver-input-box border-radius-0" type="date" value={searchCondition.endDate} onChange={(e) => {
                              changeSearchCondition('endDate', e.target.value);
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">월간 검색</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.month}
                              onChange={changeSearchCondition}
                              options={monthData}
                              keyValue={'month'}
                            />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.driver}
                              onChange={changeSearchCondition}
                              options={driverData}
                              keyValue={'driver'}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <Row>
            {dashboardItem.map((item, index) => (
            <Col xs={3} key={'collection_history_dashboard_'+index}>
              <div className="collect-history-box d-flex justify-content-between">
                <div className="d-flex flex-column justify-content-between">
                  <p className="font-size-15 mb-0">{item.text}</p>
                </div>
                <div className="d-flex flex-column justify-content-end">
                  <p className="mb-0 font-size-50 font-weight-800 line-height-1">
                    {Util.setCommaPrice(item.value)}
                    <span className="font-size-18 font-weight-600"> {item.unit}</span>
                  </p>
                </div>
              </div>
            </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-2 margin-top-40">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">수거내역 목록</span> [ 건수 : {dataList.length}건 / 수거시간 최신 순 ]</p>
            <div className="waver-pagination-btn-group" >
              <button style={{width: 143}} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
              onClick={() => {
                excelDownload()
              }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>
                    <div className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">수거일자</th>
                            <th scope="col">수거차량</th>
                            <th scope="col">운반기사</th>
                            <th scope="col">상호명</th>
                            <th scope="col">요금제</th>
                            <th scope="col">단가(원)</th>
                            <th scope="col">기본금액(원)</th>
                            <th scope="col">기본리터(ℓ)</th>
                            <th scope="col">수거현황</th>
                            <th scope="col">수거량(ℓ)</th>
                            <th scope="col">수거량(kg)</th>
                            <th scope="col">수거금액</th>
                            <th scope="col">수정</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.length > 0 && dataList.map((item, index) => {
                            return (
                              <tr key={item.id + '_' + index}>
                                <td className="pointer" >{dataList.length - index}</td>
                                <td className="pointer" >{item.collect_date}</td>
                                <td className="pointer" >{item.car?.number || ''}</td>
                                <td className="pointer" >{item.member?.username}</td>
                                <td className="pointer" >{item.company?.name}</td>
                                <td className="pointer" >{item.company?.billing_type == 'P' ? '종량제' : '정액제'}</td>
                                
                                <td className="pointer" >{Util.setCommaPrice((item.qty_type == 'l' ? item.my_contract?.price_per_l : item.my_contract?.price_per_kg_emitter) || 0)}</td>
                                <td className="pointer" >{Util.setCommaPrice(item.my_contract?.min_price)}</td>
                                <td className="pointer" >{Util.setCommaPrice(item.my_contract?.min_l)}</td>
                                <td
                                  className="pointer"
                                  style={{ color: item.state === 'Y' ? 'blue' : 'red' }}
                                >
                                    {item.state === 'Y' ? '완료' : '미완료'}
                                </td>
                                <td className="pointer" >{item.qty_type == 'l' ? Util.setCommaPrice(item.qty) : 0}</td>
                                <td className="pointer" >{item.qty_type != 'l' ? Util.setCommaPrice(item.qty) : 0}</td>                      
                                <td>{Util.setPrice(item?.total_price || 0)}</td>
                                <td>
                                  <div className="btn-group waver-common-btn-group w-90">
                                    <Button type="button" size="sm" className="w-100 waves-effect center-btn btn-common small disactive" onClick={(e) => {
                                      e.stopPropagation()
                                      getWasteBinData(item.company?.id)
                                      getTreatmentCompanyData(item.my_contract?.id)                                      
                                      setSelectedItem({
                                        id: item?.id,
                                        companyName: item.company?.id,
                                        treatmentCompanyName : item?.treatment,
                                        car: item.car?.id,  
                                        collectDate: item.collect_date,
                                        collectZone : item.my_contract.collect_zone,
                                        contract_id : item.my_contract?.id,
                                        driver: item.member?.id,
                                        report: item.report,
                                        billing_type: item.company?.billing_type == 'P' ? '종량제' : '정액제',
                                        qty: item.waste_bin_collect?.[0]?.qty || 0,
                                        is_vat: item.my_contract?.is_vat,
                                        price: item.qty_type == 'l' ? item?.my_contract?.price_per_l : item?.my_contract?.price_per_kg_emitter,
                                        min_price: item.my_contract?.min_price,
                                        min_l : item.my_contract?.min_l,
                                        memo : item.memo,
                                        qty_type : item.my_contract?.collect_type || 'l',
                                        rf_id : item.waste_bin_collect?.[0]?.rf_id,
                                        waste_bin_collect_data : item.waste_bin_collect,
                                        state : item?.state || 'I'
                                      })
                                      modalOpen('write')
                                    }}>수정</Button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        title={selectedItem?.id ? '수거 내용 수정' : '수거 내용 등록'}
        show={modalShow.write}
        onHide={() => {
          modalClose('write')
          setSelectedItem(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.car || ''}
                      onChange={changeInputCondition}
                      options={carData}
                      keyValue={'car'}
                    />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.driver || ''}
                      onChange={changeInputCondition}
                      options={driverData}
                      keyValue={'driver'}
                    />
                  </td>
                </tr>     
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거일자</td>
                  <td className="w-35">                    
                    <input className="waver-input-box w-100 border-radius-0" type="date" disabled={selectedItem?.id ? 'disabled' : ''} value={selectedItem?.collectDate} onChange={(e) => {
                      changeInputCondition('collectDate', e.target.value);
                    }} />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거상태</td>
                  <td className="w-35">                    
                    <SelectBox
                      value={selectedItem?.state || ''}
                      onChange={changeInputCondition}
                      options={stateData}
                      keyValue={'state'}                      
                    />                  
                  </td>                  
                </tr>           
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">상호명</td>
                  <td className="w-35">                    
                    <SelectBox
                      value={selectedItem?.companyName || ''}
                      onChange={changeCompanyInputCondition}
                      options={companyData}
                      keyValue={'companyName'}
                      disabled={selectedItem?.id}
                    />                  
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">처리장선택</td>
                  <td  className="w-35">
                    <SelectBox
                      value={selectedItem?.treatmentCompanyName || ''}
                      onChange={changeInputCondition}
                      options={treatmentCompanyData}
                      keyValue={'treatmentCompanyName'}
                    />                  
                  </td>
                </tr>
                 <tr>                  
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">쓰레기통 선택</td>
                  <td  className="w-35">
                    <SelectBox
                      value={selectedItem?.rf_id || ''}
                      onChange={changeWasteBinInputCondition}
                      options={wasteBinData}
                      keyValue={'rf_id'}
                    />                  
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">{selectedItem?.qty_type == 'l' ? '수거량(ℓ)' : '수거량(kg)'}</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' disabled={!selectedItem?.rf_id} value={selectedItem?.qty} placeholder={ selectedItem?.rf_id ? "수거량을 입력해 주세요." : "쓰레기통을 선택해 주세요."} onChange={(e) => {
                      changeInputCondition('qty', e.target.value)
                    }} />
                  </td>
                </tr>                
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">요금제</td>
                  <td className="w-35">{selectedItem?.billing_type}</td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">단가(원)</td>
                  <td className="w-35 text-end">{Util.setCommaPrice(selectedItem?.price)}</td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">기본금액(원)</td>
                  <td className="w-35 text-end">{Util.setCommaPrice(selectedItem?.min_price)}</td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">기본리터(ℓ)</td>
                  <td className="w-35 text-end">{Util.setCommaPrice(selectedItem?.min_l)}</td>
                </tr>
               
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={selectedItem?.memo}
                    onChange={(e)=>{
                      changeInputCondition('memo', e.target.value);
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-between w-100">
          
            <div>
              { selectedItem?.report == 'N' && 
                <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 error-bg white-text border-none" onClick={() => {
                  modalOpen('deactivate')
                }}>수거 비활성화</button>
              }
              { selectedItem?.report == 'D' && 
                <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
                 setSelectedItem({...selectedItem, report : 'N'})
                }}>수거 활성화</button>
              }
            </div>
          
          
          <div className="d-flex">
            <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveCollectItem()
            }}>{selectedItem?.id ? '수거 내용 수정' : '수거 내용 등록'}</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedItem(null)
              modalClose('write')
            }}>취소</button>
          </div>
        </div>
        }
      />


      <Modal
        title={'수거 비활성화'}
        show={modalShow.deactivate}
        onHide={() => {
          modalDeactivateClose('deactivate')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>수거 비활성화 시 "정산" 및 "신고증명서" 발행 시<br/>수거량이 제외됩니다.</p>
            <p className="mb-0">정말 비활성화 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            setSelectedItem({...selectedItem, report : 'D'})
            modalDeactivateClose('deactivate')
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalDeactivateClose('deactivate')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>
      {isLoading && 
        <div style={{
          position: "absolute",
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: 'rgba(255, 255, 255, 0.6)',
          zIndex: 99999,
          display: "flex",
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img src={loading} alt="로딩중입니다." width={'3%'}></img>
        </div>
      }
    </React.Fragment>
  )
}

export default CollectHistory
